// What kind of device Vale is open on, so install help matches it.
// Phones and tablets can't run browser extensions; they add Vale to the Home
// Screen instead (no Chrome or Google account needed).

const ua = () => (typeof navigator === "undefined" ? "" : navigator.userAgent || "");

/** iPhone, iPad or iPod. iPads on iPadOS 13+ say "Mac" but have a touch screen. */
export const isIos = () => {
  const s = ua();
  if (/iphone|ipad|ipod/i.test(s)) return true;
  return /Macintosh/i.test(s) && typeof navigator !== "undefined" && navigator.maxTouchPoints > 1;
};

export const isAndroid = () => /android/i.test(ua());

/** Any phone or tablet. */
export const isPhoneOrTablet = () => isIos() || isAndroid() || /Mobi|Tablet/i.test(ua());

/** Which device's install steps to show first: "ios" | "android" | "computer". */
export const deviceKind = () => (isIos() ? "ios" : isAndroid() ? "android" : "computer");

/** Already opened from the Home Screen (installed). */
export const isInstalled = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true);
